import {
  AdditionalConfiguration,
  ReportSection,
  ReportSectionConfigurationBase,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { participantInfo } from './itinerary-participant-info-configuration';

export class ItineraryParticipantBioConfiguration extends ReportSectionConfigurationBase {
  typeName = 'ItineraryParticipantBioConfiguration';
  nodataLocalizationKeyName = 'participantBio';
  readonly reportSection = ReportSection.ItineraryParticipantBio;
  readonly applicableReportTypes = [ReportType.Itinerary];
  readonly reportViewModelSections = [ReportViewModelSection.Itinerary_ParticipantBio];
  override totalColumnsToDisplay = 3;

  minSize = 1;
  maxSize = 3;
  defaultSize = 3;
  name = 'participantBio';
  displayName = 'Participant Bio';
  readonly availableDataSections = [
    {
      name: 'participantBio',
      displayName: 'Participant Biography',
      isSelected: true,
      canConfigure: true
    }
  ];

  override additionalConfiguration: AdditionalConfiguration = {
    isTruncated: true,
    truncationLength: 7
  };

  override readonly configurationControls = [
    {
      name: 'participantBioTruncation',
      displayName: 'Truncation',
      type: 'truncation',
      applicableDataSection: 'participantBio',
      defaultLength: 700
    }
  ];
}

export interface ExternalParticipantInfo {
  id: string;
  firstName?: string;
  lastName?: string;
  jobFunction?: string;
}

export interface ActivityParticipantsInfo {
  activityId: string;
  externalParticipantsInfo?: ExternalParticipantInfo[];
}

export interface ParticipantWithBio extends ExternalParticipantInfo {
  bio?: ParticipantBio;
}

export interface ParticipantBio {
  contactId: string;
  biography?: string;
  firstName?: string;
  lastName?: string;
}
export interface ItineraryParticipantBio {
  value?: {
    participantBios?: ParticipantBio[];
  };
}

export interface ItineraryParticipantBioData {
  [ReportViewModelSection.Itinerary_ParticipantInfo]: participantInfo;
  [ReportViewModelSection.Itinerary_ParticipantBio]: ItineraryParticipantBio;
}
